import apiClient from '@/services/rest-api-identity/apiClient'
import axios from 'axios'

const baseEndpoint = '/middleware/spec'

const config = {...apiClient.defaults}
config.headers['namespace'] = 'vsms'
const apiClientMidSpec = axios.create(config)

export const getSpec = async (queryParam) => {
  const response = await apiClientMidSpec({
    method: 'GET',
    url: baseEndpoint,
    params: {
      kind: queryParam?.kind,
      action: queryParam?.action,
    },
  })
  return response?.data.data.limiters ?? null
}
